import { i18n } from '@shared/i18n';
import { TeamService } from '@modules/team/team-service';
import { SubprogramService } from '@modules/subprogram/subprogram-service';
import Errors from '@shared/error/errors';
import { get, update } from 'lodash';

export default {
  namespaced: true,
  
  state: {
    numTeams: 0,
    numTeamsMatched: 0,
    numMinTeamMatched: 1,
    conferences: {},
    rounds: [],
    loading: false,
  },

  getters: {
    numTeams: state => state.numTeams,
    numTeamsMatched: state => state.numTeamsMatched,
    numTeamsUnmatched: state => state.numTeams - state.numTeamsMatched,
    numMinTeamMatched: state => state.numMinTeamMatched,
    conferences: state => state.conferences,
    rounds: state => state.rounds,
    loading: state => state.loading,
  },

  mutations: {
    CONFERENCES_STARTED(state) {
      state.conferences = {};
      state.loading = true;
    },
    CONFERENCES_SUCCESS(state, { rounds,conferences, numTeams, numTeamsMatched }) {
      state.rounds = rounds;
      state.conferences = conferences;
      state.numTeams = numTeams;
      state.numTeamsMatched = numTeamsMatched;
      state.loading = false;
    },
    CONFERENCES_ERROR(state) {
      state.conferences = {};
      state.rounds = [];
      state.loading = false;
    },
  },

  actions: {
    async doLoad({commit}, { subpropertyId, programId, subprogramId }) {
      try {
        commit('CONFERENCES_STARTED');
        
        const manageInput = {
          subpropertyId,
          type: 'subproperty'
        };
        
        const rounds = await SubprogramService.listRound(subpropertyId, programId, subprogramId);
        
        const { orderBy, limit, offset } = [ null, 0, 0 ];
        const filter = { subprogram: subprogramId };
        
        const { rows } = await TeamService.listForNba( filter, orderBy, limit, offset, manageInput );
        
        const { conferences, numTeamsMatched, numTeams } = rows.map((item) => ({
            id: get(item, 'id', ''),
            name: get(item, 'name', ''),
            imageUrl: get(item, 'logo[0].thumbPublicUrl', ''),
            schoolName: get(item, 'school.name', ''),
            isMatched: get(item, 'school', null) !== null ,
            conference: get(item, 'groupsPhase.conference.name', ''),
            division: get(item, 'groupsPhase.division.name', ''),
          })
        ).reduce((acumlator, current) => {
          const { conference, division, id, isMatched } = current;

          update(acumlator, `conferences.${conference}.title`, () =>  i18n(`entities.subprogram.nba.conference.${conference}.title`) );
          update(acumlator, `conferences.${conference}.divisions.${division}.title`, () =>  i18n(`entities.subprogram.nba.conference.${conference}.division.${division}`));
          update(acumlator, `conferences.${conference}.divisions.${division}.teams.${id}`, () => current);
          update(acumlator, 'numTeamsMatched', (num) => isMatched ? num + 1 : num);
          update(acumlator, 'numTeams', (num) => num + 1);

          return acumlator;
        }, { conferences: {}, numTeamsMatched: 0, numTeams: 0 });
        
        commit('CONFERENCES_SUCCESS', { rounds, conferences, numTeamsMatched, numTeams });
      } catch (error) {
        Errors.handle(error);
        commit('CONFERENCES_ERROR');
      }
    },
    
    async doStartRegularSeason({ commit }, { subpropertyId, programId, subprogramId}) {
      try {
        await SubprogramService.startRegularSeason({ subpropertyId, programId, subprogramId });
        return true;
      } catch (error) {
        Errors.handle(error);
        return false;
      }
    },

    async doStartPlayoffs({ commit }, { subpropertyId, programId, subprogramId}){
      try {
        return await SubprogramService.startPlayoffs({ subpropertyId, programId, subprogramId });
      } catch (error) {
        Errors.handle(error);
        return false;
      }
    }
  }
};